var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from "@angular/core";
import { FlightCheckInComponent } from "@ibe.components/booking/flights/flight-check-in/flight-check-in.component";
import { CHECK_IN_STATUS_OPEN, CHECK_IN_STATUS_DONE, CHECK_IN_STATUS_CLOSED, CHECK_IN_STATUS_PENDING } from "@ibe.config";
import { INDRADateService } from "@ibe.services/date.indra.service";
import { INDRAIbeAdminConfigService } from "@ibe.services/ibeadmin-config.service";
import { INDRAStorageService } from "@ibe.services/storage.indra.service";
var INDRAFlightCheckInComponent = /** @class */ (function (_super) {
    __extends(INDRAFlightCheckInComponent, _super);
    function INDRAFlightCheckInComponent(dateService, ibeAdminConfigService, storage) {
        var _this = _super.call(this) || this;
        _this.dateService = dateService;
        _this.ibeAdminConfigService = ibeAdminConfigService;
        _this.storage = storage;
        _this.flight_check_in_status = '';
        return _this;
    }
    INDRAFlightCheckInComponent.prototype.ngOnInit = function () {
        this.flight_check_in_status = this.INDRA_setStatusMessage();
        // this.INDRA_goToUrl('externalURLs.checkInNow');
    };
    INDRAFlightCheckInComponent.prototype.INDRA_setStatusMessage = function () {
        switch (this.flight_check_in.status) {
            case CHECK_IN_STATUS_PENDING:
                return 'Check-in opens ' + this.INDRA_getTimeToCheckin();
            case CHECK_IN_STATUS_OPEN:
                return 'Check-in now';
            case CHECK_IN_STATUS_DONE:
                return 'Check-in done';
            case CHECK_IN_STATUS_CLOSED:
                return 'Check-in closed';
            default:
                return;
        }
    };
    INDRAFlightCheckInComponent.prototype.INDRA_getStatusMessageTranslated = function () {
        switch (this.flight_check_in.status) {
            case CHECK_IN_STATUS_PENDING:
                return 'bookingsList.button.checkInOpen';
            case CHECK_IN_STATUS_OPEN:
                return 'bookingsList.button.checkInNow';
            case CHECK_IN_STATUS_DONE:
                return 'bookingsList.button.checkInDone';
            case CHECK_IN_STATUS_CLOSED:
                return 'bookingsList.button.checkInClosed';
            default:
                return;
        }
    };
    INDRAFlightCheckInComponent.prototype.INDRA_getDayLabel = function () {
        if (this.flight_check_in.status === CHECK_IN_STATUS_PENDING || this.flight_check_in.status == 'not available') {
            var timediff = Math.floor(this.dateService.INDRA_getRemainingTimeInSeconds(this.flight_check_in.time));
            var days = Math.floor(timediff / 60 / 60 / 24);
            var dayLabel = void 0;
            if (days > 1) {
                dayLabel = this.dateService.INDRA_formatDate(this.flight_check_in.time, 'MMM DD');
            }
            else if (days === 1) {
                dayLabel = 'bookingsList.text.tomorrow';
            }
            else if (days <= 0) {
                dayLabel = 'bookingsList.text.today';
            }
            return dayLabel;
        }
    };
    INDRAFlightCheckInComponent.prototype.INDRA_getAtLabel = function () {
        if (this.flight_check_in.status === CHECK_IN_STATUS_PENDING || this.flight_check_in.status == 'not available') {
            return 'bookingsList.text.timeAt';
        }
    };
    INDRAFlightCheckInComponent.prototype.INDRA_getAriaLabelMessage = function () {
        switch (this.flight_check_in.status) {
            case 'not available':
                return 'bookingsList.aria.checkInForFlightNotAvailable' + this.INDRA_getTimeToCheckin();
            case CHECK_IN_STATUS_OPEN:
                return 'bookingsList.aria.checkInForFlightIsOpenNow';
            case CHECK_IN_STATUS_DONE:
                return 'bookingsList.aria.checkInIsDone';
            default:
                return;
        }
    };
    // Print aria label for button
    INDRAFlightCheckInComponent.prototype.INDRA_printAriaLabelMessage = function () {
        switch (this.flight_check_in.status) {
            case 'not available':
                return 'Check-in for flight is not available yet, it opens ' + this.INDRA_getTimeToCheckin();
            case CHECK_IN_STATUS_OPEN:
                return 'Check-in for flight is open now, click here to open a new window and start check-in process';
            case CHECK_IN_STATUS_DONE:
                return 'Check-in for flight is done';
            default:
                return;
        }
    };
    INDRAFlightCheckInComponent.prototype.INDRA_getTimeToCheckin = function () {
        var timediff = Math.floor(this.dateService.INDRA_getRemainingTimeInSeconds(this.flight_check_in.time));
        var days = Math.floor(timediff / 60 / 60 / 24);
        var dayLabel;
        if (days > 1) {
            dayLabel = this.dateService.INDRA_formatDate(this.flight_check_in.time, 'MMM DD');
        }
        else if (days === 1) {
            dayLabel = 'Tomorrow';
        }
        else if (days <= 0) {
            dayLabel = 'Today';
        }
        return (dayLabel +
            ', at ' +
            this.dateService.INDRA_formatDate(this.flight_check_in.time, 'LT'));
    };
    INDRAFlightCheckInComponent.prototype.INDRA_getTimeToCheckInOnly = function () {
        if (this.flight_check_in.status === CHECK_IN_STATUS_PENDING || this.flight_check_in.status == 'not available') {
            var timediff = Math.floor(this.dateService.INDRA_getRemainingTimeInSeconds(this.flight_check_in.time));
            var days = Math.floor(timediff / 60 / 60 / 24);
            // return this.dateService.INDRA_formatDate(this.flight_check_in.time, 'LT');
            return this.dateService.INDRA_formatDate(this.flight_check_in.time, 'HH:mm');
        }
    };
    INDRAFlightCheckInComponent.prototype.INDRA_isDone = function () {
        return this.flight_check_in.status === CHECK_IN_STATUS_DONE;
    };
    INDRAFlightCheckInComponent.prototype.INDRA_isDisabled = function () {
        return this.flight_check_in.status === CHECK_IN_STATUS_CLOSED ? 'true' : null;
    };
    /**
     * @returns styles for check-in button
     */
    INDRAFlightCheckInComponent.prototype.INDRA_checkInButtonStyles = function () {
        return {
            'button-accent': this.flight_check_in.status === CHECK_IN_STATUS_OPEN,
            'button-not-available': this.flight_check_in.status === CHECK_IN_STATUS_PENDING || this.flight_check_in.status === CHECK_IN_STATUS_CLOSED,
            'button-possitive-info': this.flight_check_in.status === CHECK_IN_STATUS_DONE
        };
    };
    // Print button message label
    INDRAFlightCheckInComponent.prototype.INDRA_printStatusMessage = function () {
        return this.flight_check_in_status;
    };
    INDRAFlightCheckInComponent.prototype.INDRA_goToUrl = function (key) {
        var IDepartureDate = this.dateDeparture;
        var PNR = this.pnrData;
        var surname = this.storage.get('lastname');
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
        var urlNavigate = urlIbeAdmin.replace('${surname}', "" + surname).replace('${IDepartureDate}', "" + IDepartureDate).replace('${PNR}', "" + PNR);
        return window.open(urlNavigate);
    };
    return INDRAFlightCheckInComponent;
}(FlightCheckInComponent));
export { INDRAFlightCheckInComponent };
